var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2378 43.397L22.2159 45.0819C13.9012 42.1981 7.93188 34.2962 7.93188 25C7.93188 19.3157 10.1637 14.1528 13.7989 10.3395L16.3776 15.1613C17.1519 16.6093 18.5878 17.5847 20.2192 17.7711L23.6266 18.1603C24.8198 18.2966 25.9621 18.7197 26.9562 19.3934L27.1452 19.5215C28.0931 20.164 28.3996 21.4206 27.8538 22.4274C26.7426 24.4771 27.3996 27.037 29.3606 28.2983L30.5553 29.0666C31.5707 29.7197 31.9744 31.005 31.5146 32.1213L29.0965 37.9933C28.6637 39.0442 29.7445 40.0806 30.7763 39.6041L35.6835 37.338C36.9463 36.7549 38.0735 35.9147 38.9932 34.8712L41.0608 32.5252C41.0874 32.4951 41.1175 32.4682 41.1504 32.4453L42.8134 31.2887C43.169 31.0414 43.4542 30.706 43.6412 30.3152L45.3627 26.7168C45.9235 25.5446 45.4927 24.1381 44.3716 23.4811L36.2783 18.7375C35.2955 18.1614 34.1455 17.9383 33.0185 18.1049L31.7027 18.2995C31.4051 18.3435 31.1017 18.2788 30.848 18.1172L27.7754 16.1592L27.3614 15.7772C25.9742 14.4974 26.4512 12.2008 28.2333 11.5792L28.6799 11.4235L31.2413 10.5263L33.0611 9.8954L40.7919 7.19906C42.9897 8.63541 44.9052 10.4678 46.4371 12.5948L45.135 14.8822C44.5421 15.9237 44.343 17.1435 44.574 18.3194L44.6381 18.6459C44.9058 20.0091 46.2336 20.8925 47.5944 20.6129L49.8746 20.1444C50.2391 21.7039 50.4319 23.3294 50.4319 25C50.4319 35.1474 43.3194 43.6335 33.8077 45.7451L31.5357 43.2149C30.9958 42.6136 30.1986 42.3104 29.3957 42.4009L25.5583 42.8333C25.0725 42.888 24.6134 43.084 24.2378 43.397ZM29.1819 50C42.989 50 54.1819 38.8071 54.1819 25C54.1819 11.1929 42.989 0 29.1819 0C15.3748 0 4.18188 11.1929 4.18188 25C4.18188 38.8071 15.3748 50 29.1819 50Z",
    fill: "#F2F0FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_29",
    x: 0.181885,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_29",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.8a5372a19c5aba8e87c955eca0264c0f.svg";
export { ForwardRef as ReactComponent };